import { Injectable } from "@angular/core";
import { Location } from "@angular/common";
import { HttpInterceptor, HttpRequest, HttpResponse, HttpHandler, HttpEvent, HttpErrorResponse,
} from "@angular/common/http";

import { Observable } from "rxjs";
import { ToastrService } from "ngx-toastr";
import { GlobalDataBusService } from "../shared/global-data-bus.service";
import { map, catchError } from "rxjs/operators";
import { LoadingService } from "../services/loading.service";

@Injectable()
export class HttpConfigInterceptor implements HttpInterceptor {
  constructor(private srvTstr: ToastrService, private _srvLoading: LoadingService,private _location : Location) {}
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this._srvLoading.setLoading(true, request.url);
    // const token: string = localStorage.getItem("token");
   const token: string = localStorage.getItem("UseTokenConf");
  //  const token: string = localStorage.getItem("AdminTocken");
    var boolAddToken: boolean = true
    var blAddContent: boolean = true
    //PatientProfile/saveProfile?action
    if (request.url.endsWith('PatientProfile/saveProfile?action=1') && !request.url.startsWith('https://ipinfo.io')) {
      blAddContent = false;
    }
    if (request.url.endsWith('PatientProfile/profileLogin') && !request.url.startsWith('https://ipinfo.io')) {
      boolAddToken = false;
    }

    if (request.url.endsWith('MasterData/masterDataCollection') && !request.url.startsWith('https://ipinfo.io')) {
      boolAddToken = false;
    }

    if (request.url.endsWith('MasterData/appTheme') && !request.url.startsWith('https://ipinfo.io')) {
      boolAddToken = false;
    }

    if(this._location.path().toLowerCase().includes('/admin/')) boolAddToken = false;

    if (boolAddToken && !!token) {
      request = request.clone({ headers: request.headers.set('Authorization', 'Bearer ' + token) });
    }
    if (blAddContent) {
      if (!request.headers.has('Content-Type')) {
        request = request.clone({ headers: request.headers.set('Content-Type', 'application/json') });
      }
    }
    

    request = request.clone({ headers: request.headers.set('Access-Control-Allow-Origin', '*') });
    request = request.clone({ headers: request.headers.set('Access-Control-Allow-Headers', '*') });
    request = request.clone({ headers: request.headers.set('Access-Control-Allow-Methods', '*') });
    
    request = request.clone({ headers: request.headers.set('Accept', 'application/json') });

    GlobalDataBusService.loading.next(true)
    return next
      .handle(request).pipe(
        map((event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) {
          }
          GlobalDataBusService.loading.next(false);
          if (event instanceof HttpResponse) {
            this._srvLoading.setLoading(false, request.url);
          }
          return event;
        }),
        catchError((error: any) => {
          this._srvLoading.setLoading(false, request.url);
          return this.handlehttpError(error)
        })
      )
  }
    public handlehttpError(error: HttpErrorResponse) {
      GlobalDataBusService.loading.next(false);
        if (error.error instanceof ErrorEvent) {
          console.error("An error occurred:", error.error.message);
        }
        else if (error.status == 401) {
          this.srvTstr.error(error.message ? error.message : error.error.Message ? error.error.Message:"Un authorized", "Error");
        }
        else if (error.status == 400 || error.status == 500) {
          if (error.error.result?.Message) {
            this.srvTstr.error(error.error.result.Message,"Error");
          }
          else {
            this.showErrorMsgs(error.error.Message);
          }
        } else {
            this.srvTstr.error(`Backend returned code ${error.status}, ` + `body was: ${error.error}`, "Unknwon Error");
        }
        return Observable.throw(error);
    }
  
  showErrorMsgs(Messages: any[] =[]) {
    if (Messages == undefined || Messages == null || Messages.length == 0) {
      this.srvTstr.error("Something went wrong...");
    } else {
      Messages.forEach((Msg: any) => {
        this.srvTstr.error(Msg.Message, Msg.Key);
      });
    }
  }
}

